import { TriviaRumbleQuestionOption } from '@wwe-portal/entities/trivia-rumble.type';
import { FC, SyntheticEvent } from 'react';
import styles from './game-options.module.css';
import { Button } from '../../components/button';
import { ExplosiveCofettie } from '../../effects/cofettie/explosive-cofettie';

export const TriviaGameOptions: FC<{
  options: TriviaRumbleQuestionOption[];
  userAnswer?: string;
  correctAnswer?: string;
  isCheckingAnswer?: boolean;
  loadingText?: string;
  onAnswer: ({
    event,
    optionId,
  }: {
    event: SyntheticEvent;
    optionId: string;
  }) => void;
}> = ({
  options,
  userAnswer,
  correctAnswer,
  isCheckingAnswer,
  loadingText,
  onAnswer,
}) => {
  return (
    <div className="mb:gap-y-5 absolute inset-x-0 bottom-2.5 grid grid-cols-1 gap-x-8 gap-y-2.5 md:inset-x-[30px] md:bottom-5 md:grid-cols-2">
      {options.map((o) => (
        <div key={o.id} className="relative">
          <Button
            disabled={isCheckingAnswer || !!userAnswer}
            onClick={(e) => onAnswer({ event: e, optionId: o.id })}
            data-correct={correctAnswer && correctAnswer === o.id}
            data-incorrect={
              correctAnswer &&
              correctAnswer !== userAnswer &&
              userAnswer === o.id
            }
            className={styles.buttonFilter}
            data-id={`${o.id}_trivia_test_answers_button`}
            loading={Boolean(
              isCheckingAnswer &&
                correctAnswer == null &&
                userAnswer &&
                userAnswer === o.id
            )}
            loadingText={loadingText}
          >
            {o.option}
          </Button>
          {o.id === userAnswer &&
            userAnswer &&
            correctAnswer &&
            userAnswer === correctAnswer && (
              <ExplosiveCofettie className="absolute inset-0 inset-y-[-40px] z-50" />
            )}
        </div>
      ))}
    </div>
  );
};
